const TotalES = (data, xCategories, title = "") => ({
  chart: {
    type: "column"
  },
  title: {
    text: `属性別の総合満足度指数${title}`
  },
  colors: ["#4FBF6D"],
  xAxis: {
    categories: xCategories,
    crosshair: true
  },
  yAxis: {
    min: 0,
    max: 100,
    title: null,
    tickInterval: 10,
    labels: {
      formatter() {
        return this.value;
      }
    }
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{point.y:.1f}`
      }
    },
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: null,
      data
    }
  ],
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  }
});

export default TotalES;



// WEBPACK FOOTER //
// ./src/models/TotalESIndex.js